var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomerBirthday(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9999 15.5999C13.6744 15.5999 12.5999 16.6744 12.5999 17.9999V59.9999C12.5999 61.3254 13.6744 62.3999 14.9999 62.3999H56.9999C58.3254 62.3999 59.3999 61.3254 59.3999 59.9999V17.9999C59.3999 16.6744 58.3254 15.5999 56.9999 15.5999H14.9999ZM7.6499 17.9999C7.6499 12.698 9.69797 10.6499 14.9999 10.6499H56.9999C62.3018 10.6499 64.3499 12.698 64.3499 17.9999V59.9999C64.3499 65.3018 62.3018 67.3499 56.9999 67.3499H14.9999C9.69797 67.3499 7.6499 65.3018 7.6499 59.9999V17.9999Z",
    fill: "#346751"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.375 4.5C50.239 4.5 51.75 5.82216 51.75 7.45312V17.2969C51.75 18.9278 50.239 20.25 48.375 20.25C46.511 20.25 45 18.9278 45 17.2969V7.45312C45 5.82216 46.511 4.5 48.375 4.5Z",
    fill: "#346751"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.625 4.5C25.489 4.5 27 5.82216 27 7.45312V17.2969C27 18.9278 25.489 20.25 23.625 20.25C21.761 20.25 20.25 18.9278 20.25 17.2969V7.45312C20.25 5.82216 21.761 4.5 23.625 4.5Z",
    fill: "#346751"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 29.25C9 28.0074 10.4222 27 12.1765 27H59.8235C61.5778 27 63 28.0074 63 29.25C63 30.4926 61.5778 31.5 59.8235 31.5H12.1765C10.4222 31.5 9 30.4926 9 29.25Z",
    fill: "#346751"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerBirthday);
export default __webpack_public_path__ + "static/media/customer-birthday.b05ab7dad8105c0eff9c532816bb7311.svg";
export { ForwardRef as ReactComponent };